/**
 * 用户是否查看过新功能强提醒的键的公共前缀
 */
export const TIPS_VIEW_STATE_PREFIX = 'tips_view_state';

export const TIPS_VIEW_STATE_KEY_MAP = {
  QUARTER_REPORT_CONTEXT_MENU_TIPS: `${TIPS_VIEW_STATE_PREFIX}_quarter_report_context_menu`,
  YEAR_REPORT_PAGE: `${TIPS_VIEW_STATE_PREFIX}_year_report_page`,
};

export const TIPS_VIEW_STATE_KEYS = [
  TIPS_VIEW_STATE_KEY_MAP.QUARTER_REPORT_CONTEXT_MENU_TIPS,
  TIPS_VIEW_STATE_KEY_MAP.YEAR_REPORT_PAGE,
];
